import {
  decreaseStock as decreaseStockAda,
} from '@bitComponents/adabyronCloud/catalogue';


export function decreaseStock(params, context) {
  const {
    productOffering, colorId, storageId,
  } = params;
  try {
    const data = {
      productOffering,
      idColor: colorId,
      idCapacidad: storageId,
    };
    decreaseStockAda(data, context);
  } catch (error) {
    console.log('error', error);
  }
}
